import { PlayerEvent } from 'shared-types/player-event';

export enum MultiScreenEventTypes {
  IpadToTv = 'multiscreenevent',
  TvToIpad = 'externalscreenevent',
}

export class MultiScreenEvent extends Event {
  public actionType: PlayerEvent;
  public actionData?: string | null;
  public actionTimestamp: number;

  constructor(
    type: MultiScreenEventTypes,
    eventType: PlayerEvent,
    eventData?: string | null,
    eventTimestamp: number = Date.now(),
  ) {
    super(type);
    this.actionType = eventType;
    this.actionData = eventData;
    this.actionTimestamp = eventTimestamp;
  }
}

export class IpadToTvMultiScreenEvent extends MultiScreenEvent {
  constructor(eventType: PlayerEvent, eventData?: string | null, eventTimestamp?: number) {
    super(MultiScreenEventTypes.IpadToTv, eventType, eventData, eventTimestamp);
  }
}

export class TvToIpadMultiScreenEvent extends MultiScreenEvent {
  constructor(eventType: PlayerEvent, eventData?: string | null, eventTimestamp?: number) {
    super(MultiScreenEventTypes.TvToIpad, eventType, eventData, eventTimestamp);
  }
}
